import classnames from 'classnames';
import React from 'react';
import { NavLink } from 'react-router-dom';
import Count from '../../Count/Count';
import styles from '../navbar.module.scss';
import MainWrapper from 'MainWrapper';
import { useSelector } from 'react-redux';
import { RootState } from 'v2/models';
import { NavItem } from '../Navbar';

interface NavBarLinkProps {
  item: NavItem;
  handleExpand: (expanded: boolean) => void;
}

const NavBarLink = ({ item, handleExpand }: NavBarLinkProps) => {
  const unreadChatMessages = useSelector(
    (state: RootState) => state.chat.unreadMessages
  );

  return (
    <MainWrapper key={item.label} isReady={true}>
      <NavLink
        key={item.label}
        className={classnames(
          'nav-link mr-4 position-relative mb-lg-0 no-wraping-text',
          styles.navLinks,
          {
            [styles.hideDesktop]: item.hideDesktop,
            [styles.hideMobile]: item.hideMobile,
            [styles.navLinkTitle]: item.title,
            [styles.navLinkLine]: item.line,
          }
        )}
        to={item.to}
        isActive={(_, location) => location.pathname.includes(item.key)}
        onClick={() => handleExpand(false)}
        data-cy={`navbar:${item.key}-link`}
        data-testid={item.key}
      >
        {item.label}
        {item.icon && (
          <img src={item.icon} alt="icon" className={styles.iconOption} />
        )}
        {item.getCounter ? (
          <Count
            className={styles.linkCounter}
            value={item.getCounter(unreadChatMessages)}
          />
        ) : null}
      </NavLink>
    </MainWrapper>
  );
};

export default NavBarLink;
